import { render } from "./MultipleBtnMenu.vue?vue&type=template&id=c6a9d29a"
import script from "./MultipleBtnMenu.vue?vue&type=script&lang=js"
export * from "./MultipleBtnMenu.vue?vue&type=script&lang=js"

import "./MultipleBtnMenu.vue?vue&type=style&index=0&id=c6a9d29a&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__